// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__li1OI","footer-inner-container":"Footer_footer-inner-container__dcPuA","content":"Footer_content__BIoV4"};